import Icon from "assets/icons/success.svg?react";
import styles from "./index.module.scss";

export const SuccessIcon = () => {
    return <Icon className={styles["icon"]} />;
};
